import getSelectedNode from './getSelectedNode';
export default function getFolderIdForSelectedNode() {
    var selectedNode = getSelectedNode();
    switch (selectedNode.type) {
        case 1 /* Persona */:
            return selectedNode.searchFolderId;
        case 5 /* PrivateDistributionList */:
            return selectedNode.data.searchFolderId;
        case 3 /* Search */:
            // Treat favorite search node the same as search, in that
            // it doesn't map to an actual folder Id
            return null;
        default:
            return selectedNode.id;
    }
}
//# sourceMappingURL=getFolderIdForSelectedNode.js.map